import React, { useState, useEffect, useRef } from "react";
import classes from "./ImageInput.module.css";
import Input from "@/components/Input/Input";
import { cn } from "@/utils/cn";
import { AttachmentIconWhite } from "@/constant/imagePath";

const ImageInput = ({
  id,
  formFormik,
  error,
  fieldName,
  label,
  existingImageUrl = null,
  usePreview = false,
  clickablePreview = false,
  className = null,
  inputContainerClass = null,
  imagePreviewContainer = null,
  imagePreviewWrapper = null,
  required = true,
  ...props
}) => {
  const [imagePreview, setImagePreview] = useState(existingImageUrl);
  const fileInputRef = useRef(null);

  // Update preview when a new file is selected
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        formFormik.setFieldValue(fieldName, file); // set the file in Formik
      };
      reader.readAsDataURL(file);
    }
  };

  // Update preview when entering edit mode with an existing image
  useEffect(() => {
    if (existingImageUrl) {
      setImagePreview(existingImageUrl);
    }
  }, [existingImageUrl]);

  const handleClickImage = () => {
    if (clickablePreview && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <>
      {imagePreview && (
        <div className={imagePreviewContainer || classes.imagePreviewContainer}>
          <div className="mt-1">{clickablePreview && label}</div>
          <div className={imagePreviewWrapper || classes.imagePreviewWrapper}>
            {!usePreview && (
              <div
                onClick={clickablePreview ? handleClickImage : undefined}
                className="relative w-fit cursor-pointer group"
              >
                {/* Image Preview */}
                <img
                  src={imagePreview}
                  alt={`${label} Preview`}
                  className={cn(
                    classes.imagePreview,
                    "transition duration-300"
                  )}
                />

                {/* Hover Effect: Dark Overlay + Icon */}
                {clickablePreview && (
                  <div className="z-20 absolute inset-0 bg-black/50 flex items-center justify-center group-hover:!opacity-100 opacity-0 transition duration-300">
                    <img
                      src={AttachmentIconWhite}
                      className="h-10"
                      alt="Attachment icon"
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      <Input
        required={required}
        id={id}
        type="file"
        onChange={handleFileChange}
        labelClass={classes.label}
        label={label}
        className={
          clickablePreview && imagePreview
            ? "hidden"
            : className || classes.inputDiv
        }
        inputContainerClass={inputContainerClass || classes.input}
        value={formFormik.values[fieldName]}
        setValue={(val) => formFormik.setFieldValue(fieldName, val)}
        errorTextClass={classes.errorText}
        errorText={
          (formFormik.touched[fieldName] && formFormik.errors[fieldName]) ||
          (error?.status === 422 &&
            error?.response?.data?.errors?.[fieldName]?.join(" "))
        }
        inputRef={fileInputRef}
        {...props}
      />

      {clickablePreview && (
        <input
          type="file"
          ref={fileInputRef}
          className="hidden"
          onChange={handleFileChange}
        />
      )}
    </>
  );
};

export default ImageInput;
